import { Trophy, Zap, ShieldCheck, Star } from "lucide-react";

const LEVEL_STYLES = {
  rookie: { color: "#A1A1AA", label: "ROOKIE", Icon: ShieldCheck },
  gamer: { color: "#007AFF", label: "GAMER", Icon: Zap },
  pro: { color: "#FF2D55", label: "PRO", Icon: Trophy },
  elite: { color: "#FFD700", label: "ELITE", Icon: Star },
};

export function LevelBadge({ level = "rookie", size = "md", showIcon = true, testId }) {
  const style = LEVEL_STYLES[level] || LEVEL_STYLES.rookie;
  const { Icon } = style;
  const sizeCls = size === "sm" ? "text-xs px-2 py-0.5" : size === "lg" ? "text-lg px-4 py-1.5" : "text-sm px-3 py-1";
  return (
    <span
      data-testid={testId || `level-badge-${level}`}
      className={`inline-flex items-center gap-1.5 font-display uppercase tracking-widest rounded ${sizeCls}`}
      style={{
        color: style.color,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: style.color,
        background: `${style.color}12`,
      }}
    >
      {showIcon && <Icon size={size === "sm" ? 12 : size === "lg" ? 18 : 14} />}
      {style.label}
    </span>
  );
}

export function LevelProgress({ level, xp, levelInfo, testId }) {
  const style = LEVEL_STYLES[level] || LEVEL_STYLES.rookie;
  const currentThreshold = levelInfo?.current_threshold ?? 0;
  const nextThreshold = levelInfo?.next_threshold;
  const pct = nextThreshold
    ? Math.min(100, Math.max(0, ((xp - currentThreshold) / (nextThreshold - currentThreshold)) * 100))
    : 100;

  return (
    <div data-testid={testId} className="w-full">
      <div className="flex items-baseline justify-between mb-2">
        <div className="flex items-center gap-2">
          <LevelBadge level={level} />
          <span className="text-white/60 text-xs uppercase tracking-widest">{xp} XP</span>
        </div>
        {nextThreshold ? (
          <span className="text-white/40 text-xs uppercase tracking-widest">
            {levelInfo.xp_to_next} XP to {levelInfo.next}
          </span>
        ) : (
          <span className="text-[#FFD700] text-xs uppercase tracking-widest font-bold">MAX LEVEL</span>
        )}
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {["rookie", "gamer", "pro", "elite"].map((tier, i) => {
          const tierOrder = ["rookie", "gamer", "pro", "elite"];
          const currentIdx = tierOrder.indexOf(level);
          const isFilled = i < currentIdx;
          const isCurrent = i === currentIdx;
          const barColor = i <= currentIdx ? LEVEL_STYLES[tier].color : "#262626";
          return (
            <div
              key={tier}
              className="h-2 rounded-sm overflow-hidden"
              style={{ background: "#1a1a1a", border: `1px solid ${barColor}40` }}
            >
              <div
                className="h-full"
                style={{
                  width: isFilled ? "100%" : isCurrent ? `${pct}%` : "0%",
                  background: barColor,
                  transition: "width 400ms ease-out",
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
